import React, { useState } from 'react';
import { CircleMarker, Tooltip } from 'react-leaflet';

const calculateRadius = (markerSize: number) => {
  switch (markerSize) {
    case 1:
      return 5;
    case 2:
      return 10;
    case 3:
      return 15;
    case 4:
      return 18;
    case 5:
      return 20;
    default:
      return 5;
  }
};

interface CustomMarkerProps {
  company: string;
  count: string;
  index: number;
  lat: number;
  location: string;
  long: number;
  markerColor: string;
  markerSize: number;
  status: string;
  type: string;
}

const fadeRowHighlight = (rowElement: HTMLElement) => {
  rowElement.classList.add('active');
  setTimeout(() => {
    rowElement.classList.add('fade-out');
  }, 1000);
  setTimeout(() => {
    rowElement.classList.remove('active');
    rowElement.classList.remove('fade-out');
  }, 1500);
};

const CustomMarker = ({
  company,
  count,
  index,
  lat,
  location,
  long,
  markerColor,
  markerSize,
  status,
  type,
}: CustomMarkerProps) => {
  const [strokeColor, setStrokeColor] = useState(markerColor);
  const radius = calculateRadius(markerSize);

  return (
    <CircleMarker
      center={[lat, long]}
      eventHandlers={{
        mouseover: () => {
          setStrokeColor('black');
        },
        mouseout: () => {
          setStrokeColor(markerColor);
        },
        click: () => {
          const rowElement = document.getElementById(String(index));
          // if the reader is filtering results and this element isn't visible, return
          if (!rowElement) return;

          rowElement.style.scrollMarginTop = '100px';
          fadeRowHighlight(rowElement);
          rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
      }}
      radius={radius}
      pathOptions={{ color: strokeColor }}
      fillColor={markerColor}
      opacity={1}
      fillOpacity={0.8}
      stroke={true}
      weight={1}
    >
      <Tooltip direction="top" className="w-[200px] text-wrap">
        <b>{company}</b>
        <br />
        {count} {type}s in {location}
        <br />
        Status: {status}
      </Tooltip>
    </CircleMarker>
  );
};

export default CustomMarker;
